// src/WayneAIPlatformFrontend/src/hooks/useStreamingAgentIds.ts
import { useChatStream } from '@/stores/chatStream.store';
import type { AgentId } from '@/services/ws/types';
import { useMemo } from 'react';

export function useStreamingAgentIds(): readonly AgentId[] {
  const map = useChatStream((s) => s.streamingByAgentId);
  return useMemo(() => (Object.keys(map) as AgentId[]).filter((k) => Boolean(map[k])), [map]);
}
